import type { BookingSummary, PoiSummary } from '@linktivity/tata';

export const PoiDataType = {
  BookingSummary: 'booking',
  PoiSummary: 'poi'
} as const;

export type PoiData =
  | {
      type: typeof PoiDataType.BookingSummary;
      bookingSummary: BookingSummary;
      poiSummary?: PoiSummary;
    }
  | {
      type: typeof PoiDataType.PoiSummary;
      poiSummary: PoiSummary;
      bookingSummary?: never;
    };

export interface POI {
  id: string;
  name: string;
  description: string;
  category: string;
  rating: number;
  tags: string[];
  cta?: string;
  image?: string;
  lng?: number;
  lat?: number;
  url?: string;
  data: PoiData;
}
